import { ChangeEvent, useState } from "react";
import { useTranslation } from "react-i18next";
import { Fields } from "../../types/SchemaFactory";
import { FormikProps } from "formik";
import { getMetaParameterValue } from "../../validation-schemas/SchemaFactory";

interface CustomTextAreaProps<T> {
    form: FormikProps<T>;
    name: keyof T;
    fields: Fields<T>;

    textAreaClassName?: string;
    restrainerClassName?: string;
    wrapClassName?: string;

    pattern?: RegExp;
    charactersRestrictionKey?: string;
    charactersRestrictionClassName?: string;
    disabled?: boolean;
}

function CustomTextArea<T>(props: CustomTextAreaProps<T>) {
    const [isFocused, setIsFocused] = useState(false);
    const { t } = useTranslation();
    const onChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
        if (props.pattern && !props.pattern.test(e.target.value)) {
            e.preventDefault();
            return;
        }
        if (!props.form.touched[props.name]) {
            props.form.setFieldTouched(props.name as string, true);
        }
        props.form.handleChange(e);
    };

    return (
        <div className={`textarea-wrap ${isFocused && "border-textFaded"} ${props.wrapClassName}`}>
            <div className={`textarea-restrainer ${props.restrainerClassName}`}>
                <textarea
                    value={props.form.values[props.name] as string}
                    name={props.name as string}
                    placeholder={t(props.fields[props.name].placeholderKey)}
                    onChange={onChange}
                    maxLength={+getMetaParameterValue(props.fields[props.name], "max")}
                    className={`textarea scrollbar-popup ${props.textAreaClassName}`}
                    onFocus={() => setIsFocused(true)}
                    onBlur={() => setIsFocused(false)}
                    disabled={props.disabled}
                />
            </div>
            {props.charactersRestrictionKey && (
                <span className={`textarea-char-restriction ${props.charactersRestrictionClassName}`}>{`${
                    ((props.form.values[props.name] as string) || "").length
                }/${props.fields[props.name].max} ${t(props.charactersRestrictionKey)}`}</span>
            )}
        </div>
    );
}

export default CustomTextArea;
